/**
 * PCO-scoped hooks introduced for the PCO Log + Funding section (ADR 0002).
 *
 *   useProjectTotals()          6-up strip data (top of PCO Log)
 *   usePcoTranches(pcoId)       Funding tranche list for one PCO
 *
 * Existing hooks that already cover PCO data:
 *   useSettingsPcos()           PCO list with computed money fields
 *   usePcoCumulative(pcoId)     cumulative breakdown (rollups namespace)
 *
 * Kept as plain useApiQuery wrappers for consistency with the rest of the
 * codebase (no React Query yet).
 */
import { useCallback } from 'react';
import { api } from './api';
import { useApiQuery } from './useApiQuery';

export const useProjectTotals = () =>
  useApiQuery((t, signal) => api.pcos.projectTotals(t, { signal }));

export function usePcoTranches(pcoId: string | null) {
  const fetcher = useCallback(
    (t: string, signal: AbortSignal) => {
      if (!pcoId) return Promise.reject(new Error('usePcoTranches: pcoId is required'));
      return api.pcos.listTranches(t, pcoId, { signal });
    },
    [pcoId],
  );
  return useApiQuery(fetcher, [pcoId]);
}
